import { render } from "./FormUsuarios.vue?vue&type=template&id=83c15500&scoped=true"
import script from "./FormUsuarios.vue?vue&type=script&lang=js"
export * from "./FormUsuarios.vue?vue&type=script&lang=js"

import "./FormUsuarios.vue?vue&type=style&index=0&id=83c15500&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-83c15500"

export default script